<template>
  <div class="content">
    <div class="row">
      <typeahead-input
          class="col-10"
          v-model="team"
          :suggestion-data="filteredTeams"
          key-attribute="id"
          @filter="teamFilter = $event"
          placeholder="Nach Team- oder Trainernamen suchen">
        <template v-slot:suggestion="{suggestion}">
          <div class="row">
            <div class="col-6">{{ suggestion.name }}</div>
            <div class="col-6"
                 v-if="!suggestion.coach.cpu">
              - {{ suggestion.coach.name }}
            </div>
          </div>
        </template>
      </typeahead-input>
    </div>
    <hr/>
    <div class="row">
      <div class="form-group form-inline col-10">
        <label for="newTeamNameInput">Namen des Teams ändern in:</label>
        <input id="newTeamNameInput"
               type="text"
               size="32"
               class="form-control ms-2"
               v-model="newTeamName"/>
        <button class="btn btn-sakali btn-sm ms-2"
                @click="changeTeamName">
          Teamnamen ändern
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import TypeaheadInput from "@/components/global/TypeaheadInput";
import {mapActions} from 'vuex'

export default {
  data() {
    return {
      team: null,
      teamFilter: '',
      newTeamName: ''
    }
  },
  asyncComputed: {
    filteredTeams() {
      return new Promise((resolve, reject) =>
          this.$api.get('/search/teams-and-coaches', {params: {q: this.teamFilter}})
              .then(response => resolve(response.data))
              .catch(() => reject('')))
    }
  },
  methods: {
    ...mapActions(['messageAction', 'handleErrorAction']),
    changeTeamName() {
      this.$api.post('/teams', {
        id: this.team.id,
        name: this.newTeamName
      }).then(response => {
        this.messageAction({
          type: 'info',
          message: 'Der Teamname wurde geändert in ' + response.data.name
        })
      }).catch(error => this.handleErrorAction(error))
    }
  },
  components: {
    TypeaheadInput
  }
}
</script>